import { useEffect } from 'react';
import { redirectToAppIfInstalled } from '@/lib/deepLink';
import { isNativeMiloraApp } from '@/lib/native-deep-link';

/**
 * Hook that attempts to redirect to the mobile app if installed.
 * Should be used in the root component (App.tsx) to handle deep linking.
 */
export function useDeepLinkRedirect() {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    if (isNativeMiloraApp()) {
      return;
    }

    const params = new URLSearchParams(window.location.search);
    if (params.get('no_deep_link') === '1') {
      return;
    }

    redirectToAppIfInstalled(window.location.href).then((redirected) => {
      if (redirected) {
        console.log('Redirected to mobile app');
      }
    });
  }, []);
}
